import * as React from 'react';
import { SVGProps } from 'react';

const SvgLegoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.334 7.841a.743.743 0 0 1 .702-.062L12 11.192l7.965-3.413A.743.743 0 0 1 21 8.46v8.257a.743.743 0 0 1-.45.683l-8.257 3.539a.743.743 0 0 1-.585 0L3.45 17.4a.743.743 0 0 1-.45-.683V8.461c0-.25.126-.482.334-.62Zm1.152 1.747v6.64L12 19.45l7.515-3.22V9.588l-7.222 3.095a.743.743 0 0 1-.585 0L4.486 9.588Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 11.257c.41 0 .743.333.743.743v8.257a.743.743 0 1 1-1.486 0V12c0-.41.333-.743.743-.743ZM9.144 6.147a.743.743 0 0 1-.39.975L4.035 9.144a.743.743 0 0 1-.585-1.366L8.17 5.757a.743.743 0 0 1 .975.39ZM14.856 6.147a.743.743 0 0 1 .976-.39l4.718 2.021a.743.743 0 0 1-.585 1.366l-4.719-2.022a.743.743 0 0 1-.39-.975Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.263 3.384C10.023 3.13 11.007 3 12 3c.993 0 1.977.13 2.737.384.378.126.728.29.998.508.264.212.547.556.547 1.03s-.283.818-.547 1.03c-.27.218-.62.383-.998.51-.76.252-1.744.383-2.737.383-.993 0-1.977-.13-2.737-.384-.378-.126-.727-.291-.998-.509-.264-.212-.546-.556-.546-1.03s.282-.818.546-1.03c.27-.217.62-.382.998-.508ZM12 4.485c-.884 0-1.7.119-2.267.308-.133.044-.24.088-.325.13.085.04.192.085.325.129.567.189 1.383.307 2.267.307.884 0 1.7-.118 2.268-.307.132-.044.24-.088.324-.13a2.719 2.719 0 0 0-.324-.13c-.567-.188-1.384-.307-2.268-.307Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.461 4.18c.41 0 .743.332.743.742v2.281c.01.013.027.03.05.053.102.098.284.224.555.349.538.248 1.316.441 2.191.441.876 0 1.654-.193 2.191-.441.271-.125.454-.251.556-.35a.651.651 0 0 0 .05-.052v-2.28a.743.743 0 1 1 1.485 0v2.359c0 .46-.268.817-.507 1.046a3.531 3.531 0 0 1-.962.626c-.743.343-1.734.578-2.813.578-1.079 0-2.07-.235-2.813-.578-.37-.17-.706-.38-.962-.626-.238-.23-.506-.587-.506-1.046v-2.36c0-.41.332-.742.742-.742Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgLegoIcon;
